import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { StateModalPageRoutingModule } from './state-modal-routing.module';

import { StateModalPage } from './state-modal.page';
import { SharedModule } from '../shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    StateModalPageRoutingModule,
    SharedModule,
  ],
  declarations: [StateModalPage]
})
export class StateModalPageModule {}
